import { getDate } from '@/lib/tools/date-util'
import { cardNumberFilter } from '@/lib/tools/bank-card'
import * as _ from 'lodash'
import { JSEncrypt } from 'jsencrypt'
import store from '@/vuex/index'

const webDetailTradeType = [{
  value: 'DEBIT',
  label: '消费',
  options: [{
    value: 'PROCESSING',
    label: '处理中'
  },
  {
    value: 'PENDING',
    label: '付款中'
  },
  {
    value: 'SUCCESS',
    label: '成功'
  },
  {
    value: 'FAILED',
    label: '失败'
  },
  {
    value: 'CANCELED',
    label: '交易撤销'
  },
  {
    value: 'REVIEW',
    label: '待审核'
  }
  ]
},
{
  value: 'REFUND',
  label: '退款',
  options: [{
    value: 'SUCCESS',
    label: '成功'
  },
  {
    value: 'FAILED',
    label: '失败'
  },
  {
    value: 'PROCESSING',
    label: '处理中'
  }
  ]
},
{
  value: 'AUTH',
  label: '预授权',
  options: [{
    value: 'PROCESSING',
    label: '处理中'
  },
  {
    value: 'SUCCESS',
    label: '成功'
  },
  {
    value: 'FAILED',
    label: '失败'
  },
  {
    value: 'PENDING',
    label: '付款中'
  }
  ]
},
{
  value: 'CAPTURE',
  label: '预授权完成',
  options: [{
    value: 'PROCESSING',
    label: '处理中'
  },
  {
    value: 'SUCCESS',
    label: '成功'
  },
  {
    value: 'FAILED',
    label: '失败'
  }

  ]
},
{
  value: 'VOID',
  label: '预授权撤销',
  options: [{
    value: 'PROCESSING',
    label: '处理中'
  },
  {
    value: 'SUCCESS',
    label: '成功'
  },
  {
    value: 'FAILED',
    label: '失败'
  }
  ]
},
{
  value: 'APPROVE',
  label: '审核通过',
  options: [{
    value: 'PROCESSING',
    label: '处理中'
  },
  {
    value: 'SUCCESS',
    label: '成功'
  },
  {
    value: 'FAILED',
    label: '失败'
  }
  ]
},
{
  value: 'REJECT',
  label: '审核拒绝',
  options: [{
    value: 'PROCESSING',
    label: '处理中'
  },
  {
    value: 'SUCCESS',
    label: '成功'
  },
  {
    value: 'FAILED',
    label: '失败'
  }
  ]
}

]
const webDetailStatus = [{
  value: 'PROCESSING',
  label: '处理中'
},
{
  value: 'PENDING',
  label: '付款中'
},
{
  value: 'SUCCESS',
  label: '成功'
},
{
  value: 'FAILED',
  label: '失败'
},
{
  value: 'CANCELED',
  label: '取消'
},
{
  value: 'REVIEW',
  label: '待审核'
}
]

// 余额账户业务类型
// 资金流水业务类型
window.fundTypeLangList = [
  {
    value: '',
    zh: '全部',
    en: 'All'
  },
  {
    value: 'PURCHASE',
    zh: '付款',
    en: 'Payment'
  },
  {
    value: 'PURCHASE_FEE',
    zh: '付款手续费',
    en: 'Payment fee'
  },
  {
    value: 'DEPOSIT',
    zh: '循环保证金收取',
    en: 'Rolling Reserve'
  },
  {
    value: 'REFUND',
    zh: '退款',
    en: 'Refund'
  },
  {
    value: 'REFUND_FEE',
    zh: '退款手续费',
    en: 'Return fee'
  },
  {
    value: 'DEPOSIT_RETURN',
    zh: '循环保证金退款返还',
    en: 'Rolling Reserve Release For Refund'
  },
  {
    value: 'DEPOSIT_RELEASE',
    zh: '循环保证金到期返还',
    en: 'Rolling Reserve Expired Release'
  },
  {
    value: 'CHARGE_BACK',
    zh: '拒付扣款',
    en: 'Chargeback deduction'
  },
  {
    value: 'CB_ARBITRATION_FEE',
    zh: '拒付仲裁费扣款',
    en: 'Chargeback Arbitration Fee'
  },
  {
    value: 'CHARGE_BACK_RETURN',
    zh: '拒付返还',
    en: 'Chargeback Cancellation'
  },
  {
    value: 'CB_ARBITRATION_FEE_RETURN',
    zh: '拒付仲裁费返还',
    en: 'Chargeback Arbitration Fee Retrun'
  },
  {
    value: 'CHARGE_BACK_FEE',
    zh: '拒付手续费',
    en: 'Chargeback fee'
  },
  {
    value: 'CHARGE_BACK_SUPP_FEE',
    zh: '拒付阶梯手续费',
    en: 'Chargeback Step-rate Fee'
  },
  {
    value: 'CHARGE_BACK_FEE_RETURN',
    zh: '拒付手续费返还',
    en: 'Chargeback Fee retrun'
  },
  {
    value: 'WITH_DRAW',
    zh: '提现',
    en: 'Withdrawal'
  },
  {
    value: 'WITH_DRAW_FEE',
    zh: '提现手续费',
    en: 'Withdrawal fee'
  },
  {
    value: 'DEPOSIT_RELEASE_REVERSE',
    zh: '循环保证金到期返还撤销',
    en: 'Rolling Reserve Expired Release Cancel'
  },
  {
    value: 'DECLINE_FEE',
    zh: '固定手续费',
    en: 'Fixed fee'
  },
  {
    value: 'OPEN_ACCOUNT_FEE',
    zh: '开户费用',
    en: 'Open account fee'
  },
  {
    value: 'TECHNICAL_SERVICES_FEE',
    zh: '技术服务费用',
    en: 'Technical service fee'
  },
  {
    value: 'YEAR_FEE',
    zh: '年费',
    en: 'Yearly fee'
  },
  {
    value: 'MONTH_FEE',
    zh: '月费',
    en: 'Monthly fee'
  },
  {
    value: 'FIX_DEPOSIT',
    zh: '固定保证金收取',
    en: 'Fixed deposit'
  },
  {
    value: 'FIX_DEPOSIT_RETURN',
    zh: '固定保证金返还',
    en: 'Fixed Deposit Return'
  },
  {
    value: 'CHARGE_BACK_WARN_FEE',
    zh: '拒付预警手续费',
    en: 'Chargeback warn fee '
  },
  {
    value: 'WITH_DRAW_REVERSE',
    zh: '提现返还',
    en: 'Withdraw funds return'
  },
  {
    value: 'WITH_DRAW_FEE_REVERSE',
    zh: '提现手续费返还',
    en: 'Withdrawal fee return'
  }

]

// 拒付扣款、拒付返还、拒付仲裁费扣款、拒付仲裁费返还，提现
// 冻结账户业务类型
window.frozenLangList = [{
  value: 'All',
  zh: '全部',
  en: 'All'
},
{
  value: 'WITH_DRAW_REQUEST',
  zh: '打款请求',
  en: 'Withdrawal Request '
},
{
  value: 'WITH_DRAW',
  zh: '提现',
  en: 'Withdrawal'
},
{
  value: 'CHARGE_BACK',
  zh: '拒付扣款',
  en: 'Chargeback deduction'
},
{
  value: 'CHARGE_BACK_RETURN',
  zh: '拒付返还',
  en: 'Chargeback Cancellation'
},
{
  value: 'CB_ARBITRATION_FEE',
  zh: '拒付仲裁费扣款',
  en: 'Chargeback Arbitration Fee'
},

{
  value: 'CB_ARBITRATION_FEE_RETURN',
  zh: '拒付仲裁费返还',
  en: 'Chargeback Arbitration Fee Retrun'
},
{
  value: 'WITH_DRAW_CANCEL',
  zh: '打款失败',
  en: 'Withdraw funds return'
}

]

window.depositAccountList = [{
  value: 'All',
  zh: '全部',
  en: 'All'
},
{
  value: 'DEPOSIT',
  zh: '循环保证金收取',
  en: 'Rolling Reserve'
}, {
  value: 'DEPOSIT_RETURN',
  zh: '循环保证金退款返还',
  en: 'Rolling Reserve Release For Refund'
}, {
  value: 'DEPOSIT_RELEASE',
  zh: '循环保证金到期返还',
  en: 'Rolling Reserve Expired Release'
}
]

window.fixDepositAccountList = [{
  value: 'All',
  zh: '全部',
  en: 'All'
},
{
  value: 'FIX_DEPOSIT',
  zh: '固定保证金收取',
  en: 'Fixed Deposit'
}, {
  value: 'FIX_DEPOSIT_RETURN',
  zh: '固定保证金退还',
  en: 'Fixed Deposit Return'
}
]

export default {
  encrypt(pwd, publicKey) {
    const publicMapper = {
      local: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
      development: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
      test: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
      sandbox: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALVIdHfBpUCPgzAcPpmQsb72+Bhhxltvaa0+bxE4KdELDOvyQRCTf77dQX4DLDZmc5esj9zVN6YjxGbW1SW2lp8CAwEAAQ==',
      // production: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJqp3laSw+Dt1LQ5bIuaYE1fXriLgqr0gwKjySb3xUbmqsU7FrChuHTKUrByBtzQj9Oj8pHvEbQonp3Fs0n28W8CAwEAAQ==',
      production: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJqp3laSw+Dt1LQ5bIuaYE1fXriLgqr0gwKjySb3xUbmqsU7FrChuHTKUrByBtzQj9Oj8pHvEbQonp3Fs0n28W8CAwEAAQ=='
    }
    const _publicKey = publicMapper[process.env.NODE_ENV] || publicKey
    // try {
    // 	var publicKey = forge.pki.publicKeyFromPem(`-----BEGIN PUBLIC KEY-----${_publicKey}-----END PUBLIC KEY-----`);
    // 	// convert string to UTF-8 encoded bytes
    // 	var buffer = forge.util.createBuffer(pwd);
    // 	var bytes = buffer.getBytes();
    // 	// encrypt data with a public key using RSAES PKCS#1 v1.5
    // 	var encrypted = publicKey.encrypt(bytes, 'RSAES-PKCS1-V1_5');
    // 	// base64-encode encrypted data to send to server
    // 	var b64Encoded = forge.util.encode64(encrypted);
    // 	console.log(b64Encoded);
    // 	// alert(b64Encoded);
    // 	return b64Encoded

    // } catch (error) {
    // 	console.error(error)
    // }

    const encryptor = new JSEncrypt()
    // 设置公钥
    encryptor.setPublicKey(_publicKey)
    // 加密数据
    return encryptor.encrypt(pwd)
  },
  // 银行卡加密
  encryptionBankCard(bankCard) {
    if (bankCard) {
      bankCard = bankCard.toString()
      const endlen = bankCard.length
      const fourFist = bankCard.substr(0, 4)
      const last = bankCard.substr(endlen - 4, 4)
      return `${fourFist} **** **** ${last}`
    }
  },
  // 银行卡加密
  encryptionPhone(phone) {
    if (phone) {
      phone = phone.toString()
      const last = phone.substr(phone.length - 4, 4)
      return `*******${last}`
    }
  },
  toPercent(val) {
    const percent = val * 100 || 0
    return percent.toFixed(1) + '%'
  },
  /**
   * 小数转换为百分比，保留2位小数
   * 0.3  => 30.00%
   * @param twodDecimal
   * @returns {*}
   */
  twodDecimal(val) {
    const percent = val * 100 || 0
    return percent.toFixed(2) + '%'
  },
  /**
   * 格式化金额过滤器
   * 123456.78  =>  123,456.78
   * @param money
   * @returns {*}
   */
  money(money) {
    if (!money) {
      return '0.00'
    }
    if (money < 0.01) {
      return '0.00'
    }
    money = money + ''
    let num
    // 无小数点数字
    if (money.includes('.')) {
      num = +money.substr(0, money.indexOf('.') + 3)
    } else {
      num = +money + '.00'
    }
    // 截取小数点后2位
    // 12=> 12  12.1=> 12.1 12.126=> 12.12
    return ((isNaN(num) ? '0.00' : num) + '').replace(
      /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
      '$&,'
    )
  },
  // 截取小数点后两位，并且为负数则返回“0.00”
  pureMoney(money) {
    if (isNaN(+money)) {
      return '0.00'
    }
    if (!money) {
      return '0.00'
    }
    if (money < 0.01) {
      return '0.00'
    }
    money = money + ''
    let num
    // 无小数点数字
    if (money.includes('.')) {
      num = +money.substr(0, money.indexOf('.') + 3)
    } else {
      num = +money + '.00'
    }
    // 截取小数点后2位
    // 12=> 12  12.1=> 12.1 12.126=> 12.12
    return +num
  },
  // 截取小数点后两位，并且为负数不返回“0.00”，而是直接返回结果
  pureMoneyFushu(money) {
    if (isNaN(+money)) {
      return '0.00'
    }

    money = money + ''
    let num
    // 无小数点数字
    if (money.includes('.')) {
      num = +money.substr(0, money.indexOf('.') + 3)
    } else {
      num = +money + '.00'
    }
    // 截取小数点后2位

    return +num
  },
  nullReplace(money) {
    if (money === 0 || money === '0') {
      return '-'
    } else {
      return money
    }
  },
  /**
   * 格式化string金额过滤器
   * 123456.78  =>  123,456.78
   * @param money
   * @returns {*}
   */
  stringtoMoney(stringMoney) {
    if (!stringMoney) {
      return '0.00'
    }
    const num = parseFloat(stringMoney).toFixed(2)
    return ((isNaN(num) ? '0.00' : num) + '').replace(
      /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
      '$&,'
    )
  },
  right(value, len) {
    if (!value || value.length < len) {
      return value
    }
    return value.substring(value.length - len)
  },
  // 根据语言，获取账户余额业务类型、资金流水业务类型
  getEmerOptions(type, lang) {
    const ret = window[type].map(item => {
      const value = item.value
      const label = item[lang]
      return {
        label,
        value
      }
    })
    return ret
  },
  getLabel(type, value, lang) {
    const ret = window[type].find(item => item.value === value)
    if (ret) {
      return ret[lang]
    }
  },

  // 获取申诉结果
  getMerchantDealStatusLabel(depositStatus, lang = 'zh') {
    switch (depositStatus) {
      case 'expired':
        return lang === 'zh' ? '已过期' : 'Expired'

      case 'failed':
        return lang === 'zh' ? '申诉失败' : 'Failure'

      case 'pending':
        return lang === 'zh' ? '待处理' : 'Pending Appeal'

      case 'processed':
        return lang === 'zh' ? '已处理' : 'Processed'

      case 'refunded':
        return lang === 'zh' ? '已退款' : 'Refunded'

      case 'revoked':
        return lang === 'zh' ? '持卡人撤回' : 'Chargeback Reversal'

      case 'success':
        return lang === 'zh' ? '申诉成功' : 'Success'

      case 'waiver_appeal':
        return lang === 'zh' ? '放弃申诉' : 'Waive Appeal'

      default:
        return ''
    }
  },

  // 获取拒付原因
  getChineseReason(depositStatus, lang = 'zh') {
    switch (depositStatus) {
      case 'DUTY':
        return lang === 'zh' ? '定责类' : 'Fraud'
      case 'NO_RECEIVED':
        return lang === 'zh' ? '未收到货' : 'Not Received'
      case 'WRONG_GOODS':
        return lang === 'zh' ? '货不对板' : 'Not as described'
      case 'OTHERS':
        return lang === 'zh' ? '其他类' : 'Others'
      default:
        return lang === 'zh' ? '其他类' : 'Others'
    }
  },
  // 获取拒付进度中文描述
  getChargebackType(depositStatus, lang = 'zh') {
    switch (depositStatus) {
      case 'retrieval':
        return lang === 'zh' ? '调单' : 'Retrieval'
      case '1st_chargeback':
        return lang === 'zh' ? '首次拒付' : '1st Chargeback'
      case 'chargeback_reversal':
        return lang === 'zh' ? '撤销拒付' : 'Chargeback cancel'
      case '2nd_chargeback':
        return lang === 'zh' ? '二次拒付' : '2nd Chargeback'
      case 'pre_arbitration':
        return lang === 'zh' ? '预仲裁' : 'Pre-arbitration'
      case 'arbitration':
        return lang === 'zh' ? '仲裁' : 'arbitration'
    }
  },
  // 获取保证金状态中文枚举值
  getDepositStatusName(depositStatus) {
    switch (depositStatus) {
      case 'DEPOSIT':
        return '新增保证金'
      case 'DEPOSIT_RETURN':
        return '保证金退款返还'
      case 'DEPOSIT_RELEASE':
        return '保证金到期返还'
    }
  },
  // 获取保证金状态中文枚举值
  getDepositStatus(depositStatusName) {
    switch ('depositStatusName') {
      case 'PARTIAL_RETURNED':
        return '已部分返还'
      case '已返还':
        return 'TOTAL_RETURNED'
      case '持有中':
        return 'IN_POSSESSION'
      default:
        return ''
    }
  },
  // 获取保证金业务类型类型映射
  getDepositFondTypeName(type) {
    switch (type) {
      case 'DEPOSITED':
        return '入账时存入'

      case 'REFUND_RETURNED':
        return '退款时返还'

      case 'AUTO_RETURNED':
        return '保证金到期后返还'
    }
  },
  getNewFondTypeName(type, lang = 'zh') {
    switch (type) {
      case 'PREAUTHORIZE_SUCCESSFUL':
        return lang === 'zh' ? '预授权成功' : 'preauthorize successfull'

      case 'PREAUTHORIZE_FAILED':
        return lang === 'zh' ? '预授权失败' : 'preauthorize failed'

      case 'REFUND_SUCCESSFUL':
        return lang === 'zh' ? '退款成功' : 'refund successful'

      case 'REFUND_FAILED':
        return lang === 'zh' ? '退款失败' : 'refund failed'

      case 'CAPTURE_SUCCESSFUL':
        return lang === 'zh' ? '预授权确认成功' : 'capture success'

      case 'CAPTURE_FAILED':
        return lang === 'zh' ? '预授权确认失败' : 'capture failed'

      case 'PAID_SUCCESSFUL':
        return lang === 'zh' ? '付款成功' : 'paid success'

      case 'PAID_FAILED':
        return lang === 'zh' ? '付款失败' : 'paid failed'

      case 'INBOUND_SUCCESSFUL':
        return lang === 'zh' ? '入账成功' : 'inbound success'

      case 'VOID_SUCCESSFUL':
        return lang === 'zh' ? '预授权取消失败' : 'void successfull'

      case 'VOID_FAILED':
        return lang === 'zh' ? '付款成功' : 'void failed'

      case 'REVIEW':
        return lang === 'zh' ? '待审核' : 'review'

      case 'CANCELED':
        return lang === 'zh' ? '交易撤销' : 'canceled'
    }
  },
  // 业务类型名称映射
  getFondTypeName(type, lang = 'zh') {
    switch (type) {
      case 'DEBIT':
        return lang === 'zh' ? '订单入账' : 'Order account'

      case 'DEPOSIT':
        return lang === 'zh' ? '新增保证金' : 'Incoming deposit'

      case 'MERCHANT_FEE_SETTLE':
        return lang === 'zh' ? '打款手续费' : 'Remittance fee'

      case 'FEE':
        return lang === 'zh' ? '费用扣除' : 'Deduction of expenses'

      case 'REFUND':
        return lang === 'zh' ? '退款' : 'refund'

      case 'DEPOSIT_RETURN':
        return lang === 'zh' ? '保证金退款返还' : 'Deposit release'

      case 'DEPOSIT_RELEASE':
        return lang === 'zh' ? '保证金到期返还' : 'Deposit expire release'

      case 'SETTLE':
        return lang === 'zh' ? '打款' : 'Payment'

      case 'PURCHASE':
        return lang === 'zh' ? '交易' : 'Transaction'

      case 'PURCHASE_FEE':
        return lang === 'zh' ? '交易费用' : 'Transaction fee'

      case 'REFUND_FEE':
        return lang === 'zh' ? '退款费用' : 'Refund fee'
    }
  },
  // 新款交易状态类型映射
  getNewTradeTypeName(type, lang = 'zh') {
    const status = _.find(webDetailTradeType, ['value', type])
    // console.log('status', status)
    return lang === 'zh' ? status.label : status.value
  },
  getNewTradeStatus(type, lang = 'zh') {
    const status = _.find(webDetailStatus, ['value', type])
    return lang === 'zh' ? status.label : status.value
  },
  // 交易状态类型映射
  getTradeTypeName(type, lang = 'zh') {
    switch (type) {
      case 'CAPTURE_SUCCESSFUL':
        return lang === 'zh' ? '预授权确认成功' : 'Pre-authorization confirmation success'

      case 'CAPTURE_PROCESSING':
        return lang === 'zh' ? '预授权确认中' : 'Pre-authorization confirmation processing'

      case 'CAPTURE_FAILED':
        return lang === 'zh' ? '预授权确认失败' : 'Pre-authorization cancellation failure'

      case 'REFUND_PROCESSING':
        return lang === 'zh' ? '退款中' : 'Refund processing'

      case 'REFUND_SUCCESSFUL':
        return lang === 'zh' ? '退款成功' : 'Refund success'

      case 'REFUND_FAILED':
        return lang === 'zh' ? '退款失败' : 'Refund failure'

      case 'PAID_SUCCESSFUL':
        return lang === 'zh' ? '付款成功' : 'Success payment'

      case 'PAID_FAILED':
        return lang === 'zh' ? '付款失败' : 'Failed payment'

      case 'PAID_PENDING':
        return lang === 'zh' ? '付款中' : 'Paying'

      case 'PREAUTHORIZE_SUCCESSFUL':
        return lang === 'zh' ? '预授权成功' : 'Pre-authorization success'

      case 'PREAUTHORIZE_FAILED':
        return lang === 'zh' ? '预授权失败' : 'Pre-authorization failure'

      case 'CAPTURE_FULL_SUCCESSFUL':
        return lang === 'zh' ? '全部预授权确认成功' : 'All pre-authorization confirmation successfully'

      case 'CAPTURE_FULL_FAILED':
        return lang === 'zh' ? '全部预授权确认失败' : 'All pre-authorization confirmation failed'

      case 'CAPTURE_PARTIAL_SUCCESSFUL':
        return lang === 'zh' ? '部分预授权确认成功' : 'Partial pre-authorization confirmation successful'

      case 'CAPTURE_FULL_PROCESSING':
        return lang === 'zh' ? '全额预授权确认中' : 'Full pre-authorization confirmed'

      case 'CAPTURE_PARTIAL_PROCESSING':
        return lang === 'zh' ? '部分预授权确认中' : 'Partial pre-authorization confirmed'

      case 'CAPTURE_PARTIAL_FAILED':
        return lang === 'zh' ? '部分预授权确认失败' : 'Partial pre-authorization confirmation failed'

      case 'CAPTURE_EXPIRED':
        return lang === 'zh' ? '预授权过期' : 'Pre-authorization expired'

      case 'INBOUND_SUCCESSFUL':
        return lang === 'zh' ? '入账成功' : 'Recorded payment'

      case 'INBOUND_FAILED':
        return lang === 'zh' ? '入账失败' : 'Recorded payment'

      case 'REFUND_FULL_PROCESSING':
        return lang === 'zh' ? '全额退款中' : 'Full refunding'

      case 'REFUND_FULL_SUCCESSFUL':
        return lang === 'zh' ? '全额退款成功' : 'Full refund success'

      case 'REFUND_FULL_FAILED':
        return lang === 'zh' ? '全额退款失败' : 'Full refund failed'

      case 'REFUND_PARTIAL_PROCESSING':
        return lang === 'zh' ? '部分退款中' : 'Partial refunding'

      case 'REFUND_PARTIAL_SUCCESSFUL':
        return lang === 'zh' ? '部分退款成功' : 'Partial refund successfully'

      case 'REFUND_PARTIAL_FAILED':
        return lang === 'zh' ? '部分退款失败' : 'Partial refund failed'

      case 'REVERSAL_SUCCESSFUL':
        return lang === 'zh' ? '预授权取消成功' : 'Pre-authorization cancellation successfully'

      case 'REVERSAL_FAILED':
        return lang === 'zh' ? '预授权取消失败' : 'Pre-authorization cancellation failure'

      case 'DEPOSIT_AUTO_RETURNED':
        return lang === 'zh' ? '保证金到期后返还到预入账金额' : 'Deposit release cancellation'

      case 'REFUND_RETURNED':
        return lang === 'zh' ? '退款时返还保证金' : 'Deposit return when refunding'

      case 'CHARGE_BACK':
        return lang === 'zh' ? '争议' : 'dispute'

      case 'CHARGE_BACK_RETURNED':
        return lang === 'zh' ? '争议返还' : 'Dispute rfound'

      case 'EXPENDITURE_SUSSEESFUL':
        return lang === 'zh' ? '支出成功' : 'Expenditure successfull'

      case 'EXPENDITURE_FAILED':
        return lang === 'zh' ? '支出失败' : 'Expenditure failed'

      case 'RECEIPT':
        return lang === 'zh' ? '收入' : 'Receipt'

      default:
        return ''
    }
  },
  // 打款类型映射
  // lang 指定语言 默认zh
  getRecordState(type, lang = 'zh') {
    switch (type) {
      case 'INPROCESS':
        return lang === 'zh' ? '打款中' : 'INPROCESS'

      case 'RECEIVED':
        return lang === 'zh' ? '打款中' : 'RECEIVED'

      case 'PENDING':
        return lang === 'zh' ? '打款中' : 'PENDING'

      case 'PART_SUCCESS':
        return lang === 'zh' ? '部分打款成功' : 'PART_SUCCESS'

      case 'SUCCESS':
        return lang === 'zh' ? '打款成功' : 'SUCCESS'

      case 'FAILED':
        return lang === 'zh' ? '打款失败' : 'FAILED'

      case 'RETURN':
        return lang === 'zh' ? '退票' : 'RETURN'
    }
  },
  timestampToDatetimeNextLine(timestamp) {
    const _ = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09']
    const datetime = new Date(timestamp)
    const year = datetime.getFullYear()
    const month = datetime.getMonth() + 1
    const date = datetime.getDate()
    const hour = datetime.getHours()
    const minute = datetime.getMinutes()
    const second = datetime.getSeconds()
    return `${year}-${_[month] || month}-${_[date] || date}
    ${_[hour] || hour}:${_[minute] || minute}:${_[second] || second}`
  },
  timestampToDatetime(timestamp) {
    const _ = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09']
    const datetime = new Date(timestamp)
    const year = datetime.getFullYear()
    const month = datetime.getMonth() + 1
    const date = datetime.getDate()
    const hour = datetime.getHours()
    const minute = datetime.getMinutes()
    const second = datetime.getSeconds()
    return `${year}-${_[month] || month}-${_[date] || date} ${_[hour] || hour}:${_[minute] || minute}:${_[second] || second}`
  },
  timestampToDatetimeNohour(timestamp) {
    const datetime = new Date()
    datetime.setTime(timestamp)
    const year = datetime.getFullYear()
    const month = datetime.getMonth() + 1
    const date = datetime.getDate()
    return year + '-' + month + '-' + date
  },
  dateTime(val) {
    return getDate(val, 'YY-MM-DD HH:MM')
  },
  dateNormalTime(val) {
    return getDate(val, 'YY-MM-DD HH:MM:SS')
  },
  time(val) {
    return getDate(val, 'HH:MM:SS')
  },

  date(val) {
    val = new Date(val)
    return getDate(val, 'YY-MM-DD')
  },
  dateMonth(val) {
    return getDate(val, 'YY-MM')
  },
  bankNumber(val) {
    return cardNumberFilter(val)
  },
  platform(name, mode) {
    if (mode === 'name') {
      switch (name) {
        case 'amazon-us':
          return '北美亚马逊'
        case 'amazon-jp':
          return '日本亚马逊'
        case 'amazon-eu':
          return '欧洲亚马逊'
        case 'wish':
          return 'wish'
        case 'newegg':
          return 'newegg'
      }
    } else if (mode === 'logo') {
      switch (name) {
        case 'amazon-us':
          return 'amazon-logo'
        case 'amazon-jp':
          return 'amazon-logo'
        case 'amazon-eu':
          return 'amazon-logo'
        case 'wish':
          return 'wish-logo'
        case 'newegg':
          return 'newegg-logo'
        case 'opensky':
          return 'opensky-logo'
      }
    }
  },
  currency(name) {
    switch (name) {
      case 'USD':
        return '美元'
      case 'JPY':
        return '日元'
      case 'EUR':
        return '欧元'
      case 'CAD':
        return '加币'
      case 'GBP':
        return '英镑'
    }
  },
  getRandomNum(Min, Max) {
    const Range = Max - Min
    const Rand = Math.random()
    return Min + Math.round(Rand * Range)
  },
  getRandomcolor(index) {
    const colors = [
      '#FF8620',
      '#66B3FF',
      '#FF5D5D',
      '#795DFF',
      '#FF8620',
      '#66B3FF',
      '#FF5D5D',
      '#795DFF',
      '#FF8620',
      '#66B3FF',
      '#FF8620'
    ]
    const i = Math.ceil(Math.random() * 10)
    return colors[i + 1]
  },

  currencylist() {
    const arr = [{
      label: 'AED',
      value: 'AED'
    },
    {
      label: 'AUD',
      value: 'AUD'
    },
    {
      label: 'BND',
      value: 'BND'
    },
    {
      label: 'BRL',
      value: 'BRL'
    },
    {
      label: 'CAD',
      value: 'CAD'
    },
    {
      label: 'CHF',
      value: 'CHF'
    },
    {
      label: 'CNY',
      value: 'CNY'
    },
    {
      label: 'COP',
      value: 'COP'
    },
    {
      label: 'CZK',
      value: 'CZK'
    },
    {
      label: 'DKK',
      value: 'DKK'
    },
    {
      label: 'EGP',
      value: 'EGP'
    },
    {
      label: 'EUR',
      value: 'EUR'
    },
    {
      label: 'FJD',
      value: 'FJD'
    },
    {
      label: 'GBP',
      value: 'GBP'
    },
    {
      label: 'HKD',
      value: 'HKD'
    },
    {
      label: 'HUF',
      value: 'HUF'
    },
    {
      label: 'IDR',
      value: 'IDR'
    },
    {
      label: 'IRR',
      value: 'IRR'
    },
    {
      label: 'ISK',
      value: 'ISK'
    },
    {
      label: 'JPY',
      value: 'JPY'
    },
    {
      label: 'KRW',
      value: 'KRW'
    },
    {
      label: 'KWD',
      value: 'KWD'
    },
    {
      label: 'LAK',
      value: 'LAK'
    },
    {
      label: 'LKR',
      value: 'LKR'
    },
    {
      label: 'MOP',
      value: 'MOP'
    },
    {
      label: 'MXN',
      value: 'MXN'
    },
    {
      label: 'MYR',
      value: 'MYR'
    },
    {
      label: 'NGN',
      value: 'NGN'
    },
    {
      label: 'NOK',
      value: 'NOK'
    },
    {
      label: 'NZD',
      value: 'NZD'
    },
    {
      label: 'PHP',
      value: 'PHP'
    },
    {
      label: 'PKR',
      value: 'PKR'
    },
    {
      label: 'PLN',
      value: 'PLN'
    },
    {
      label: 'QAR',
      value: 'QAR'
    },
    {
      label: 'RUB',
      value: 'RUB'
    },
    {
      label: 'SAR',
      value: 'SAR'
    },
    {
      label: 'SCR',
      value: 'SCR'
    },
    {
      label: 'SEK',
      value: 'SEK'
    },
    {
      label: 'SGD',
      value: 'SGD'
    },
    {
      label: 'THB',
      value: 'THB'
    },
    {
      label: 'TRY',
      value: 'TRY'
    },
    {
      label: 'TWD',
      value: 'TWD'
    },
    {
      label: 'USD',
      value: 'USD'
    },
    {
      label: 'VND',
      value: 'VND'
    },
    {
      label: 'ZAR',
      value: 'ZAR'
    },
    {
      label: 'BDT',
      value: 'BDT'
    },
    {
      label: 'NPR',
      value: 'NPR'
    },
    {
      label: 'MMK',
      value: 'MMK'
    }
    ]
    return arr
  },
  permissionButton(val) {
    const asyncButton = store.getters.asyncButton
    if (asyncButton.includes(val)) return false
    else return true
  },
  permissionMenu(val) {
    const asyncMenu = store.getters.asyncMenu
    if (asyncMenu.includes(val)) return true
    else return false
  },

  getStoreType(type) {
    switch (type) {
      case 'direct':
        return window.vm.$i18n.t('storeManage.directStoreType')
      case 'franchise':
        return window.vm.$i18n.t('storeManage.franchiseStoreType')
      default:
        return ''
    }
  },
  
  getStoreStatus(status) {
    switch (status) {
      case 'APPROVE':
        return window.vm.$i18n.t('storeManage.approved')
      case 'DECLINE':
        return window.vm.$i18n.t('storeManage.decline')
      case 'PENDING':
        return window.vm.$i18n.t('storeManage.pending')
      case 'MODIFY':
        return window.vm.$i18n.t('storeManage.modify')
      default:
        return ''
    }
  },
  
  getStoreStatusIcon(status) {
    switch (status) {
      case 'APPROVE':
        return 'el-icon-success success'
      case 'DECLINE':
        return 'el-icon-error error'
      case 'PENDING':
        return 'el-icon-question question'
      case 'MODIFY':
        return 'el-icon-error error'
      default:
        return ''
    }
  },
}
